import { baseApiService } from './base'
import type { PaginatedParams, PaginatedResponse } from './common'

export interface Product extends Record<string, unknown> {
  id: string
  name: string
}

export type ProductsResponse = PaginatedResponse<Product>
export type ProductsParams = PaginatedParams

export async function getProducts(params: ProductsParams): Promise<ProductsResponse> {
  return baseApiService.fetch<ProductsResponse>('/api/etmf/masterdata/PRODUCT', {
    params
  })
}
